import React from 'react';
import './Testimonial.css';
import mmtLogo from '../assets/images/mmt.png';

function Testimonial() {
  return (
    <section className="testimonial">
      <div className="container">
        <h2 className="testimonial-heading">What our customers are saying about us</h2>
        <div className="testimonial-card">
          <div className="testimonial-avatar">
            <img
              src={mmtLogo}
              alt="MakeMyTrip"
              className="avatar-img"
            />
          </div>
          <div className="testimonial-info">
            <h4>Vikram Challur</h4>
            <span className="testimonial-role">Vice President – Hotel Supply Network</span>
            <p className="testimonial-company">MakeMyTrip Group</p>
          </div>
          <blockquote>
            "The meeting room management & food ordering solution has simplified our working in
            day to day office life! It is smooth and spares us from the repeated calls one has
            to make to the pantry to organise for service, especially when we have visitors. We
            are also able to manage our meeting schedules without any manual intervention."
          </blockquote>
          <div className="testimonial-bar"></div>
        </div>
      </div>
    </section>
  );
}

export default Testimonial;
